module.exports = __webpack_public_path__ + "img/im_scrollfeature_05.f1b449b9.jpg";